<template v-if="product">

    <PantalladeCarga v-if="creandoPDF == true" titulo="Creando Presupuesto PDF..."></PantalladeCarga>

    <div class="row align-items-sm-center col-sm-divider mb-5 mb-sm-10">
        <div class="col-sm-6 col-md-4 offset-md-2">
            <div class="text-center">
                <div class="text-primary fw-bold">

                    <div class="fs-6" :style="'color:'+colordeprecios+';'" v-if="quotation==false">Desde</div>
                    <div class="fs-6" :style="'color:'+colordeprecios+';'" v-if="quotation==true">Precio Final Personalizado</div>

                    
                    <div class="fs-5" :style="'color:'+colordeprecios+';'" v-if="productoAnterior == true"><del>{{(product.price*1.20).toFixed(2)}}€</del></div>


                    <span class="fs-4 align-top" :style="'color:'+colordeprecios+';'">{{product.currency}}</span>
                    <span class="display-1" :style="'color:'+colordeprecios+';'">{{Math.floor(product.price)}}</span>
                    <span class="fs-6" :style="'color:'+colordeprecios+';'">,{{((Math.floor(product.price)-product.price.toFixed(2))*(-100)).toFixed(0)}}</span>
                </div>

                <p>{{product.period}}</p>
            </div>
        </div>

        <div class="col-sm-6">
            <div class="ps-sm-3 ps-md-5">
                <div class="mb-4">
                    <h3 class="h5">{{product.name}}</h3>
                </div>

                <!-- List Checked -->
                <ul class="list-checked list-checked-primary mb-0">
                    
                    <li class="list-checked-item" style="color:red;" v-if="product.promotion && promocion"><b><u>PROMOCIÓN:</u> <br>{{product.promotion}}</b></li>
                    <li class="list-checked-item" v-for="(feature, index2) in product.features" :key="index2" v-html="feature"></li>

                </ul>
                <!-- End List Checked -->

            </div>
        </div>
    </div>


     <div class="mx-auto text-center" style="max-width: 31.25rem;">
        <!-- Alert -->
        <div class="alert alert-soft-primary" role="alert" style="background: #fff;">
            <div class="align-items-sm-center">

                <div style="padding-top:10px;">                
                    <button @click="clickProducto(product.cod, product.price, 'contratar')" class="btn btn-primary" v-html="product.button"></button>
                </div>

            </div>
        </div>
        <!-- End Alert -->
    </div>    

</template>

<script>

import PantalladeCarga from '.././PantalladeCarga.vue'


export default {
  name: 'Uniproducto',
  components : {PantalladeCarga},
  emits: ["clickProducto"],
  props: {
    
    product: Object,
    quotation: Boolean,
    UrlDescargaPresupuesto: String,
    productoAnterior: Boolean,
    idPresupuesto: String

  },

  data: function () {
    return {
        creandoPDF: false,
        colordeprecios: "#F78104",
        promocion: true

    }
  },

  mounted: async function(){

    if (ColorPrecios) {

        this.colordeprecios = ColorPrecios;

    }


    if (ActivatePromo) {

        if (ActivatePromo == "no")
        {
            this.promocion = false;

        } else {

            this.promocion = true;

        }

    } else {

        this.promocion = false;

    }

    
  },

  methods: {


    clickProducto : async function(producto, price, tipo){
            
        await this.$emit("clickProducto", producto, price, tipo);


    },

    descargarPDF : async function(producto, price){


        if (this.quotation == true)
        {

            await this.clickProducto(producto, price, "download");
            
            this.creandoPDF = true;

            window.location.assign(this.UrlDescargaPresupuesto);

        }

    }


  }

}
</script>


<style lang="scss" scoped>

    @media only screen and (max-width: 768px) {
        
        .display-1 {
            font-size:75pt;

        }

        .display-2 {
            font-size:75pt;

        }
        .preciosmoviles {

            margin-top:10px;
        }


    }

    @media only screen and (min-width: 768px) {

        .preciosmoviles {

            margin-left: 15px;
            margin-right: 15px;
            box-shadow: none;
            max-width: 500px;
        }

        .card-group-md-row {
            box-shadow: none;

        }

        .card-group-md-row {

            background: transparent;
            box-shadow: none;

        }


    }

    .badge {

        padding:10px;
        font-size: 10pt;
        margin:5px;
    }

    .semaforoRojo {

        background: #E1E6EE;
        color: #000;

    }
    .semaforoAmarillo {

        background: #E1E6EE;
        color: #000;
    }

    .semaforoVerde {

        background: #E1E6EE;
        color: #000;
    }


    .cuadroMedico {

        background: #D8D8D8;
        color: #000;
    }

    .individual {

        background: #F3F781;
        color: #000;
    }

    .familiar {

        background: #58ACFA;
        color: #fff;
    }

</style>